import { ScheduleCancelReason, ScheduleCancelStatus } from '../../../entities/ScheduleCancel';

type ResolveStatusParams = {
  isCancelling: boolean;
  isCancelled: boolean;
  hasCancelError: boolean;
  isSendingReason: boolean;
  isReasonSent: boolean;
};

export default class ScheduleCancelModel {
  static REASON_OPTIONS: ScheduleCancelReason[] = [
    ScheduleCancelReason.OTHER_COMMITMENT,
    ScheduleCancelReason.NO_LONGER_NEEDED,
    ScheduleCancelReason.PREFER_NOT_TO_SAY,
    ScheduleCancelReason.OTHER
  ];

  static LOADING_MESSAGE = 'Estamos cancelando seu agendamento...';

  // dividida em partes para a View destacar o trecho em negrito
  static REASON_PROMPT_MESSAGE = {
    prefix: 'Ok! ',
    highlight: 'Seu agendamento foi cancelado',
    suffix: '. Obrigada por nos avisar! Nos vemos quando for o melhor momento para você. Você poderia nos contar o motivo?'
  };

  static SENDING_REASON_MESSAGE = 'Enviando sua resposta...';

  static REASON_SUCCESS_MESSAGE = 'Obrigada por compartilhar! Sua resposta nos ajuda a melhorar.';

  static CANCEL_ERROR_MESSAGE = 'Não foi possível cancelar seu agendamento. Tente novamente.';

  static REASON_ERROR_MESSAGE = 'Não foi possível enviar o motivo. Tente novamente.';

  static resolveStatus({
    isCancelling,
    isCancelled,
    hasCancelError,
    isSendingReason,
    isReasonSent
  }: ResolveStatusParams): ScheduleCancelStatus {
    if (hasCancelError) return ScheduleCancelStatus.ERROR;
    if (isCancelling || !isCancelled) return ScheduleCancelStatus.CANCELLING;
    if (isSendingReason) return ScheduleCancelStatus.SENDING_REASON;
    if (isReasonSent) return ScheduleCancelStatus.DONE;
    return ScheduleCancelStatus.CHOOSING_REASON;
  }

  static canSelectReason(status: ScheduleCancelStatus): boolean {
    return status === ScheduleCancelStatus.CHOOSING_REASON;
  }
}
